<template>
  <div>
    <validation-provider
      :name="$t(config.name)"
      :rules="showFromAlarm ? 'required_if:units_from_alarm,from_alarm' : config.rules"
      v-slot="{ errors }"
    >
      <label class="d-block">
        {{ $t(config.name) }}
      </label>
      <v-select
        v-if="!loading"
        v-model="model"
        :options="itemsOptions"
        :clearable="true"
        :reduce="(val) => val.value"
        input-id="alarm_panel_id"
        :multiple="multiple"
        :disabled="fromAlarm"
        @input="$emit('input', model)"
      />
      <p v-else>Loading...</p>
      <p v-if="config.hint" class="mb-0 small">{{ $t(config.hint) }}</p>
      <p v-if="errors" class="small text-danger">{{ errors[0] }}</p>
    </validation-provider>
    <div class="form-group form-check mt-1" v-if="showFromAlarm">
      <validation-provider vid="units_from_alarm">
        <input
          type="checkbox"
          class="form-check-input"
          name="units_from_alarm"
          v-model="fromAlarm"
          value="from_alarm"
        />
      </validation-provider>
      <label class="form-check-label">
        {{ $t("commands.form.location.fields.from_alarm") }}
      </label>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";
import {ValidationProvider} from "vee-validate";
import axios from "@/libs/axios";

export default {
  components: {
    vSelect,
    ValidationProvider,
  },
  props: {
    value: Array | Object,
    multiple: Boolean | Number,
    config: Object,
    context: Object,
    nodeConfig: Object,
  },
  data() {
    return {
      model: null,
      items: [],
      options: [],
      fromAlarm: false,
      showFromAlarm: false,
      loading: true,
    };
  },
  created() {
    this.showFromAlarm = this.context.flowchartConfig.alarm_compatible;
    this.model = this.value || null;
    this.fromAlarm = this.showFromAlarm && this.value === "from_alarm";
  },
  async mounted() {
    await this.fetchAlarmPanels(this.context.model.units);
  },
  watch: {
    fromAlarm: {
      handler(value) {
        if (value) {
          this.$emit("input", "from_alarm");
          this.model = null;
        } else {
          this.$emit("input", null);
        }
      },
    },
    "context.model.units": {
      handler(value) {
        this.handleUnitsUpdates(value);
      },
      immediate: true
    }
  },
  computed: {
    itemsOptions() {
      if (this.options.length) {
        return this.options;
      }

      this.options = [...this.items];

      return this.options;
    },

  },
  methods: {
    async fetchAlarmPanels(facilityId) {
      this.items = [];

      if (!facilityId || facilityId === 'from_alarm') {
        this.loading = false;
        return;
      }

      this.loading = true;

      const {data} = await axios.get(`/v1/services/alarm-panel/by-facility?facility_id=${facilityId}`);
      this.items = data.data.map((item) => ({
        value: item.id,
        label: item.name,
      }));

      this.loading = false;
    },
    handleUnitsUpdates(value) {
      if (value) {
        this.options = [];
        this.items = [];
        this.model = null;
        this.fetchAlarmPanels(value);
      }
    }
  }
};
</script>

<style></style>
